const create = (jui, action) => {
  const massDeleteButton = new jui.Button({
    classNames:['delete modal-delete-button svg-ico-delete'],
    toolTip: "Delete selected assets",
    action: action
  });

  massDeleteButton.disable();

  return massDeleteButton;
};

export default {
  create
};



// WEBPACK FOOTER //
// ./src/lp/editor/buttons/mass-delete-button.js